import styled from "styled-components";
import { Nav, NavItem, FormGroup } from "react-bootstrap";

export const Wrapper = styled.div`
    .ag-theme-alpine-dark {
        font-family: Roboto !important;
    }
`;
export const HeaderWrapper = styled.span`
    font-weight: normal;
`;
export const GridWrapper = styled.div`
    height: 68vh;
    width: 100%;

    @media (max-height: 1080px) {
        height: 62vh;
    }

    .ag-header-cell {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 5px;
    }

    .ag-header-cell > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
    }

    .ag-header-cell > .ag-react-container {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .ag-header-cell > .ag-react-container > div {
        text-align: center;
    }

    .ag-cell {
        text-align: center;
        // line-height: 35px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .donor-connect-user-case-load {
        line-height: initial;
        display: flex;
        align-items: center;
    }

    .donor-connect-user-case-load > .ag-react-container {
        width: 100%;
    }

    .donor-connect-drop-down {
        display: flex;
        align-items: center;
    }

    .donor-connect-drop-down > .ag-react-container {
        width: 100%;
    }

    .action-menu {
        overflow: visible;
        border-bottom: none;
        //line-height: 28px;
        display: flex;
        align-items: center;
    }

    .action-menu.ag-cell-focus {
        border-top: 1px solid #ccc !important;
        border-right: 1px solid white !important;
        border-bottom: 1px solid white !important;
        border-left: 1px solid #ccc !important;
    }

    .ag-header {
        color: white;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
    }

    .ag-header-row {
        background-color: lightgray;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }

    .ag-row {
        z-index: 0;
    }

    .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    span.targeted > .dropdown {
        padding: 0px;
    }

    span.targeted > .dropdown > .dropdown-toggle {
        background-color: transparent;
        color: green;
        font-weight: 700;
        font-size: 16px;
        padding: 0px 10px 0px 10px;
        border: 0 none;
    }

    span.active-targeted > .dropdown > .dropdown-toggle {
        background-color: transparent;
        color: yellow;
        font-weight: 700;
        font-size: 16px;
        padding: 0px 10px 0px 10px;
        border: 0 none;
    }

    span.category > .dropdown > .dropdown-toggle {
        background-color: transparent;
        // color: green;
        font-weight: 700;
        font-size: 16px;
        padding: 0px 10px 0px 10px;
        border: 0 none;
    }

    .dropdown > .dropdown-toggle {
        font-size: ${p => p.fontSize ? p.fontSize : '12px'};
    }

    // .dropdown-menu {
    //     font-size: ${p => p.fontSize ? p.fontSize : '12px'};
    // }

    .dropdown-menu > li > a:hover, .dropdown-menu > li > a:focus {
        background-color: #ddd;
    }
`;

export const TableWrapper = styled.div`
    .table {
        border: 1px solid #eee;
        border-radius: 4px;
    }

    .table > thead > tr {
        background-color: #222628;
        color: #fff;
    }

    .table > thead > tr > th {
        text-align: center;
        border: 1px solid #fff;   
    }

    .table > tbody > tr > td {
        text-align: center;
        vertical-align: middle;
    }

    .table > tbody {
        // border: 1px solid pink;
        height: 400px;
    }

    // .table-striped>tbody>tr:nth-of-type(even) {
    //     background-color: darkgrey !important;
    //     color: #fff;
    // }

    // .table-striped>tbody>tr:nth-of-type(odd) {
    //     background-color: #181d1f !important;
    //     color: #fff;
    // }
`;

interface INavWrapperProps {
    verticalAlign?: string,
    minTabWidth?: string,
    tabHeight?: string,
    fontSize?: string
}

export const NavWrapper = styled(Nav) <INavWrapperProps>`
    // & > li {
    //     height: 52px;
    // }

    & > .acc-tabs > li {
        height: 48px;
    }

    & > .acc-tabs > li > a {
        font-size: 14px;
        font-weight: 500;
        background-color: #337ab7;
        color: white;
        // width: 160px;
        text-align: center;
        // line-height: 15px;
        padding: 5px 15px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: ${(p: INavWrapperProps) => p.verticalAlign ? p.verticalAlign : 'flex-end'};
        min-width: ${(p: INavWrapperProps) => p.minTabWidth ? p.minTabWidth + 'px !important' : '0px'};
    }

    & > .acc-tabs > li.active > a {
        color: #555;
        background-color: #fff;
    }

    & > div > .acc-pills > li > a {
        padding: 5px 7px;
        // font-size: ${(p: INavWrapperProps) => p.fontSize != null ? p.fontSize : '14px'};
    }

    & > div > .acc-pills > li > span {
        position: relative;
        display: block;
        font-size: 12px;
        padding: 5px 7px;
        color: #ccc;
    }

    & > div > .acc-pills > li > div.pill-divider {
        margin-left: 3px;
        margin-right: 3px;
        margin-top: 9px;
        height: 10px;
        width: 1px;
        background-color: #ccc;
        // border: 0.5px solid #ccc
    }

    & > li > a:hover {
        background-color: #a0c5e5;
        color: black;
    }

    & > li > a.action {
        background-color: white;
        color: black;
    }

    & > li.active > a {
        // font-size: 14px;
        // line-height: 15px;
        // padding: 5px 7.5px;
    }

    @media (max-width: 1823px) {
        & > li > a,
        & > li.active > a {
            font-size: 12px;
            min-width: 120px;
        }
    }
`;

export const ViewWrapper = styled.div`
    .modal-container {
        position: relative;
    }

    .modal-container .modal, .modal-container .modal-backdrop {
        position: absolute;
    }
`;

export const FormGroupWrapper = styled(FormGroup)`
    margin-bottom: 5px;
    display: flex;
    align-items: center;

    & > .col-lg-3 {
        padding-left: 0px;
    }
`;

interface INavItemProps {
    tabWidth?: string,
    minTabWidth?: string
}

export const NavItemWrapper = styled(NavItem) <INavItemProps>`
    // & > a {
    //     width: ${(p: INavItemProps) => p.minTabWidth ? p.minTabWidth + 'px !important' : '150px'};
    // }

    // & > a {
    //     min-width: ${(p: INavItemProps) => p.minTabWidth ? p.minTabWidth + 'px !important' : '0px'};
    // }
`;